import React from 'react';
import { FETCH_BCP_DEVELOPED } from '../queries';
import { useQuery } from '@apollo/client';
import { Spinner } from '../../../components';
import { useLocation, useSearchParams } from 'react-router-dom';
import FetchError from '../../../components/generic/FetchError';
import { FETCH_LOCATION_BCP_DEVELOPED } from '../queries/RiskHub';
import QueryErrorBoundary from '../../../components/error-handling';

type BcpDeveloped = {
  totalDeveloped: number;
  averageWeeks: number;
};

interface DataResponse {
  bcpDeveloped: BcpDeveloped;
}

export function BCPCard() {
  let [searchParams] = useSearchParams();
  const location = useLocation();
  const divisionUuid = searchParams.get('division');
  const locationUuid = searchParams.get('location');

  const pathname = location.pathname;
  const IS_LOCATION_RISK_HUB = pathname === '/location-risk-hub';

  const query = IS_LOCATION_RISK_HUB
    ? FETCH_LOCATION_BCP_DEVELOPED
    : FETCH_BCP_DEVELOPED;

  const { data, loading, error } = useQuery(query, {
    variables: {
      filter: IS_LOCATION_RISK_HUB ? { locationUuid } : { divisionUuid },
    },
  });

  const riskHubData = IS_LOCATION_RISK_HUB
    ? data?.bcpProcessAreaDeveloped
    : data?.bcpDeveloped;

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <QueryErrorBoundary error={error}>
      <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative">
        <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
          {`BCPs Developed`.toUpperCase()}
        </h2>
        <div className="h-[200px] w-full flex flex-col items-center justify-between px-2 py-3">
          <span className="font-bold text-center text-5xl text-blue tracking-wider">
            {riskHubData ? riskHubData?.totalDeveloped : 0}
          </span>
          <span className="font-normal text-xsm text-secondary-300 text-center">
            includes all locations, process areas, and processes
          </span>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-2xl text-primary-100 mt-4">
              {riskHubData ? riskHubData.averageWeeks : 0} weeks
            </span>
            <span className="text-primary-100 text-xsm text-center font-light tracking-wider">
              BCP Average Age
            </span>
          </div>
        </div>
      </div>
    </QueryErrorBoundary>
  );
}
